import React, { useMemo } from 'react'
import { PersonAffiliation } from '../../../types'
import { Section } from '../../ui'
import {
  activityYear,
  collectAllPersonActivity,
} from '../../../utils/personRecentActivity'
import { PersonActivityRowList } from './PersonActivityRows'

interface PersonActivityProps {
  affiliations: PersonAffiliation[]
}

/**
 * Full person activity history for the Aktivitet tab — year-grouped like company RecentChanges.
 */
const PersonActivity: React.FC<PersonActivityProps> = ({ affiliations }) => {
  const rows = useMemo(
    () => collectAllPersonActivity(affiliations),
    [affiliations]
  )

  return (
    <Section title="Aktivitet" emphasis compact>
      {rows.length === 0 ? (
        <p className="text-xs text-ink-500">Ingen registreret aktivitet.</p>
      ) : (
        <ol className="list-none" aria-label="Aktivitet">
          {rows.map((row, i) => {
            const year = activityYear(row.date)
            const prevYear = i > 0 ? activityYear(rows[i - 1].date) : null
            const showYear = year !== prevYear
            return (
              <React.Fragment key={`${row.kind}-${row.date}-${row.companyCvr}-${i}`}>
                {showYear && <YearBreaker year={year} />}
                <PersonActivityRowList rows={[row]} />
              </React.Fragment>
            )
          })}
        </ol>
      )}
    </Section>
  )
}

const YearBreaker: React.FC<{ year: string }> = ({ year }) => (
  <li
    aria-hidden
    className="pt-4 pb-1 first:pt-0 border-t border-rule first:border-t-0"
  >
    <span className="font-mono text-xs font-semibold uppercase tracking-wide text-ink-500">
      {year}
    </span>
  </li>
)

export default PersonActivity
